export const LETTRE_PARTIELLEMENT = 'LettrePartiellement';
export const LETTRE = 'Lettre';
export const NON_LETTRE = 'NonLettre';

export const LETTRAGE_TYPE_AVOIR = 'LettrageAvoir';
export const LETTRAGE_TYPE_REGLEMENT = 'LettrageReglement';
export const LETTRAGE_TYPE_ANNULATION_REGLEMENT = 'AnnulationReglement';

export const LETTRAGE_ETAT = [
  { etat: LETTRE_PARTIELLEMENT, libelle: 'enCoursTiers.lettrePartiellement' },
  { etat: LETTRE, libelle: 'enCoursTiers.lettre' },
  { etat: NON_LETTRE, libelle: 'enCoursTiers.nonLettre' },
];

export const LETTRAGE_TYPE = [
  { etat: LETTRAGE_TYPE_AVOIR, libelle: 'enCoursTiers.type.avoir' },
  { etat: LETTRAGE_TYPE_REGLEMENT, libelle: 'enCoursTiers.type.reglement' },
  { etat: LETTRAGE_TYPE_ANNULATION_REGLEMENT, libelle: 'enCoursTiers.type.annulationReglement' },
];
